import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types';
import auth from '../auth/'
import { withRouter } from "react-router";

const AuthenticatedRoute = (props) => {
  const { history, location, onCheck, component } = props;
  const InnerComponent = component;
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const loginCheck = () => {
    const failureCallback = () => {
      setIsLoggedIn(false);
      history.push("/login");
    }

    const successCallback = (response) => {
      if (response && onCheck){
        const check = onCheck(response);
        if (check) {
          if (/^https?:\/\//i.test(check)) {
            window.location.assign(check); // redirecciona a la url
          } else {
            history.push(check);
          }
        } else {
          setIsLoggedIn(true);
        }
      } else if (!!response) {
        setIsLoggedIn(true);
      } else {
        failureCallback();
      }
    }

    auth.isLoggedIn().then(successCallback).catch(failureCallback);
  }

  useEffect(loginCheck, [location.pathname]);
  useEffect(loginCheck, []);

  return isLoggedIn && InnerComponent && (
    <InnerComponent {...props} />
  );
}

AuthenticatedRoute.propTypes = {
  onCheck: PropTypes.func, // callback que retorna una url a la que redirecciona y recibe como parámetro la respusta del servidor al checkear token
}

export default withRouter(AuthenticatedRoute)



// WEBPACK FOOTER //
// ./src/AuthenticatedRoute/AuthenticatedRoute.js